import { Box } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';

interface ILayoutWithoutDrawer {
    children: React.ReactNode;
}

const LayoutWithoutDrawer = ({ children }: ILayoutWithoutDrawer) => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     dispatch(setHeaderTitle({color: '#fff'}));
    // }, []);
    return (
        <Box
            sx={{
                // height: '100vh',
                // marginTop: '64px',
                // paddingInline: '20px',
                position: 'relative',
                height: 'calc(100svh - 120px)'
            }}
        >
            {children}
        </Box>
    );
};

export default LayoutWithoutDrawer;
